// export const BACKEND_URL = 'http://markitone_2022.demo2n.aimesoft.com:9080/api/v1'; // DEV
// export const BACKEND_URL = 'http://localhost:2130/api/v1';  //DEMO
export const BACKEND_URL = 'https://category.markitone.jp/api/v1';  //DEPLOY